import styled from '@mui/material/styles/styled';

export const Img = styled('img')(() => ({
  width:'100%',
  height: 'auto',
  objectFit: 'cover',
  borderRadius: '6px',
  marginTop: 12
}));